<table class="documents-table">
    <thead>
        <tr>
            <th><span (click)="orderBy('documentNumber')" translate>COMPLAINT|Nr zgłoszenia <icc-sort-order-icon [sort]="columnSortOptions['documentNumber']"></icc-sort-order-icon></span></th>
            <th *ngIf="viewComplaintOrderNumber"><span style="cursor: default" translate>COMPLAINT|Nr zamówienia pierwotnego</span></th>
            <th><span (click)="orderBy('client')" translate>COMPLAINT|Klient <icc-sort-order-icon [sort]="columnSortOptions['client']"></icc-sort-order-icon></span></th>
            <th *ngIf="!viewAssignedDistributor && !viewAssignedAuthorizedRetailer"><span (click)="orderBy('priority')" translate>COMPLAINT|Priorytet <icc-sort-order-icon [sort]="columnSortOptions['priority']"></icc-sort-order-icon></span></th>
            <th *ngIf="viewAssignedDistributor"><span translate>COMPLAINT|Przypisany dystrybutor</span></th>
            <th *ngIf="viewAssignedAuthorizedRetailer"><span translate>COMPLAINT|Przypisany APS</span></th>
            <th>
                <span (click)="orderBy('created')" translate>INTERFACE|Data utworzenia <icc-sort-order-icon [sort]="columnSortOptions['created']"></icc-sort-order-icon></span>
                <span (click)="orderBy('modified')" translate>INTERFACE|Data modyfikacji <icc-sort-order-icon [sort]="columnSortOptions['modified']"></icc-sort-order-icon></span>
            </th>
            <th>
                <span (click)="orderBy('assignedToCompany')">{{ 'COMPLAINT|Przypisanie' | translate }}<icc-sort-order-icon [sort]="columnSortOptions['assignedToCompany']"></icc-sort-order-icon></span>
            </th>
            <th translate>COMPLAINT_APPOINTMENT|Protokoły</th>
            <th>
                <span (click)="orderBy('apsStatus')" translate>COMPLAINT|Status APS <icc-sort-order-icon [sort]="columnSortOptions['apsStatus']"></icc-sort-order-icon></span>
                <span (click)="orderBy('distributorStatus')" translate>COMPLAINT|Status dystrybutora <icc-sort-order-icon [sort]="columnSortOptions['distributorStatus']"></icc-sort-order-icon></span>
                <span (click)="orderBy('manufacturerStatus')" translate>COMPLAINT|Status producenta <icc-sort-order-icon [sort]="columnSortOptions['manufacturerStatus']"></icc-sort-order-icon></span>
            </th>
            <th translate>INTERFACE|Opcje</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let document of orderedDocuments  | paginate: { itemsPerPage: documentsInPage, currentPage: page, totalItems: totalItems };trackBy:trackByUuid">
            <ng-container *ngTemplateOutlet="documentRow; context: {document: document, node: document }"></ng-container>
        </ng-container>
    </tbody>
</table>
<pagination-controls
            (pageChange)="onChangePage($event)"
            [previousLabel]="'INTERFACE|Poprzednia' | translate"
            [nextLabel]="'INTERFACE|Następna' | translate"
            maxSize="6"
></pagination-controls>

<ng-template #documentRow let-document="document" let-node="node">
    <tr [class.documents-table__row--error]="node.multipleWorkflows">
        <td class="documents-table__name" (click)="open(document)" >
            <span *ngIf="document?.documentNumber">
                {{ document?.documentNumber?.join ? document?.documentNumber.join('') : '' }}
            </span>

            <span *ngIf="mode === 'index' && documentActionsAccess.get(document.uuid)?.transferChanges" class="integrity-warning" (click)="showIntegrityWarning(document); $event.stopPropagation();">
                <br><icc-icon name="exclamation-triangle"></icc-icon> <span>{{ 'INTERFACE|Uwaga!' | translate }}</span>
            </span>
        </td>
        <td *ngIf="viewComplaintOrderNumber" class="documents-table__name" (click)="open(document)" >
            <ng-container *ngIf="getUniqueDistributorOrderNumbers(document).length > 0">
                <span *ngFor="let distributorOrderNumber of getUniqueDistributorOrderNumbers(document)">
                    {{ distributorOrderNumber }}
                </span>
            </ng-container>
        </td>
        <td class="documents-table__client" (click)="open(document)">
          <ng-container *ngIf="document?.clientName" >
            {{ document?.clientName }}
            <br>
          </ng-container>
          <ng-container *ngIf="!document?.clientName && document.authorizedRetailerCompanyId !== null" >
            {{ 'COMPLAINT|Zgłoszenie APSa' | translate }}
            <br>
          </ng-container>
          <ng-container *ngIf="!document?.clientName && document.authorizedRetailerCompanyId === null" >
            {{ 'COMPLAINT|Zgłoszenie dystrybutora' | translate }}
            <br>
          </ng-container>
          <small *ngIf="document?.installationAddress" >
            {{ document?.installationAddress }}
          <br>
          </small>
          <a
            *ngIf="document.locationSource === 'manual' || document.locationDescription || document.locationPartialMatchConfirmed"
            class="documents-table__location-link"
            (click)="openLocationDialog(document); $event.stopPropagation()"
          >
            {{ 'COMPLAINT|Lokalizacja' | translate }}
          </a>
        </td>
        <td *ngIf="!viewAssignedDistributor && !viewAssignedAuthorizedRetailer" class="documents-table__priority" (click)="open(document)">
            {{ getPriority(document) }}
        </td>
        <td *ngIf="viewAssignedDistributor" class="documents-table__assigned-distributor" (click)="open(document)">
            {{ getAssignedDistributor(document) }}
        </td>
        <td *ngIf="viewAssignedAuthorizedRetailer" class="documents-table__assigned-distributor" (click)="open(document)">
            {{ getAssignedAuthorizedRetailer(document) }}
        </td>
        <td class="documents-table__date" (click)="open(document)" >
            {{ document?.created | date : 'short' }}<br>
            {{ document?.modified | date : 'short' }}
        </td>
        <td class="documents-table__assign-to" (click)="open(document)">
            {{ getAssignedTo(document) }}<br>
        </td>
        <td class="documents-table__protocols">
            <button
                *ngIf="complaintHasProtocols(document)"
                iccButton
                appearance="outline"
                (click)="viewProtocolsList(document)"
                class="multiline-button"
            >
                {{ 'COMPLAINT_APPOINTMENT|Podgląd protokołów' | translate }}
            </button>
        </td>
        <td class="documents-table__status" (click)="open(document)" *ngIf="showDocumentStatuses">
            <div *ngIf="document.assignedTo === 'authorizedRetailer' && document.clientName?.length" class="documents-table__status-container">
                <icc-complaint-status [status]="getStatus(document.authorizedRetailerStatusId)!"></icc-complaint-status>
            </div>
            <div *ngIf="!(document.assignedTo === 'authorizedRetailer' && document.clientName?.length)" class="documents-table__status-container__text">
                {{ getStatus(document.authorizedRetailerStatusId)?.name || ('INTERFACE|Niezdefiniowany' | translate) }}
            </div>
            <div *ngIf="((document.assignedTo === 'distributor' && document.clientName?.length) || (document.assignedTo === 'authorizedRetailer' && !document.clientName?.length) || (document.assignedTo === 'distributor' && !document.clientName?.length && document.authorizedRetailerCompanyId))" class="documents-table__status-container">
                <icc-complaint-status [status]="getStatus(document.distributorStatusId)!"></icc-complaint-status>
            </div>
            <div *ngIf="!((document.assignedTo === 'distributor' && document.clientName?.length) || (document.assignedTo === 'authorizedRetailer' && !document.clientName?.length) || (document.assignedTo === 'distributor' && !document.clientName?.length && document.authorizedRetailerCompanyId))" class="documents-table__status-container__text">
                {{ getStatus(document.distributorStatusId)?.name || ('INTERFACE|Niezdefiniowany' | translate) }}
            </div>
            <div *ngIf="(document.assignedTo === 'manufacturer' || (document.assignedTo === 'distributor' && !document.clientName?.length && !document.authorizedRetailerCompanyId))" class="documents-table__status-container">
                <icc-complaint-status [status]="getStatus(document.manufacturerStatusId)!"></icc-complaint-status>
            </div>
            <div *ngIf="!(document.assignedTo === 'manufacturer' || (document.assignedTo === 'distributor' && !document.clientName?.length && !document.authorizedRetailerCompanyId))" class="documents-table__status-container__text">
                {{ getStatus(document.manufacturerStatusId)?.name || ('INTERFACE|Niezdefiniowany' | translate) }}
            </div>
        </td>
        <td>
            <div class="documents-table__options">
                <button iccButton appearance="secondary"  (click)="open(document)" *ngIf="mode === 'index' && !parent">
                  {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                </button>
                <button
                    iccButton
                    *ngIf="correctionButtonAccess.get(document.uuid)"
                    appearance="outline"
                    (click)="issueCorrection(document)"
                    class="multiline-button"
                >
                    {{ 'COMPLAINT|Korekta wystawiona' | translate }}
                </button>
            </div>
        </td>
    </tr>
</ng-template>
